module.exports = __webpack_public_path__ + "img/shout-icon.9cec266e.png";